import { render, staticRenderFns } from "./AwardsWidget.vue?vue&type=template&id=42d37019&"
import script from "./AwardsWidget.vue?vue&type=script&lang=ts&"
export * from "./AwardsWidget.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports